
import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p341418121121157120',
  apiBaseUrl: 'https://www.blockdance-test.xyz',
  authOrigin: 'https://lumi-auth-web-git-dev-blockdance-web.vercel.app',
})

